export default "__VITE_ASSET__fhRp1h4V__"